import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "ll-settings h-full overflow-auto pa-2",
  style: {
    "min-width": "250px",
    "flex": "0 0 22%"
  },
  "data-cy": "settings-navigation"
};
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
};
const _hoisted_3 = {
  class: "mb-1"
};
const _hoisted_4 = {
  key: 1,
  class: "mb-1"
};
const _hoisted_5 = {
  key: 2,
  class: "mb-1"
};
const _hoisted_6 = {
  key: 3,
  class: "mb-1"
};
const _hoisted_7 = {
  key: 4,
  class: "mb-1"
};
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import RouteService from '@/services/RouteService';
import LlIcon from '@/components/LlIcon.vue';
import LlListItem from '@/components/LlListItem.vue';

// Define props for Angular services

export default {
  __name: 'Settings',
  props: {
    userService: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;

    // Initialize Pinia stores
    const meStore = useMeStore();
    const {
      me,
      features,
      permissions,
      terms,
      company
    } = storeToRefs(meStore);

    // Initialize route service
    const routeService = new RouteService(props);

    // Current route tracking
    const currentRoute = ref('');

    // Update current route from $state
    const updateCurrentRoute = () => {
      if (props.state?.current?.name) {
        currentRoute.value = props.state.current.name;
      }
    };

    // Check if a route is currently active
    const isRouteActive = routeName => {
      return currentRoute.value === routeName || currentRoute.value?.startsWith(routeName + '.');
    };

    // Navigation method
    const navigateTo = routeName => {
      routeService.go(routeName);
    };

    // Route change handler for access control
    const handleRouteChange = (event, toState) => {
      if (toState?.name?.indexOf('.company') > 0 && !me.value?.permissions?.firm?.setup) {
        // Allow Microsoft 365 tab if user has the feature
        if (toState.name === 'settings.company.m365' && me.value?.features?.m365) {
          return; // Don't redirect, allow access
        }

        // Agent Access answers a non-administrator on the page (ERR-008) rather than bouncing them to
        // user settings, because that is the screen ERR-003 tells a refused user to go and look at.
        if (toState.name === 'settings.company.agentAccess' && me.value?.features?.agentSettings) {
          return;
        }
        // Block access to company settings and redirect to user settings
        if (event) {
          event.preventDefault();
        }
        routeService.go('settings.user');
      }
    };

    // Load user data and set up route watching
    onMounted(() => {
      // Set initial route
      updateCurrentRoute();

      // Watch for route changes if rootScope is available
      if (props.rootScope) {
        // Listen for state change events
        const deregisterRouteWatch = props.rootScope.$on('$stateChangeStart', handleRouteChange);
        const deregisterRouteSuccess = props.rootScope.$on('$stateChangeSuccess', updateCurrentRoute);

        // Clean up listeners on unmount
        onBeforeUnmount(() => {
          if (deregisterRouteWatch) deregisterRouteWatch();
          if (deregisterRouteSuccess) deregisterRouteSuccess();
        });
      }
    });

    // Watch for route changes via state service if available
    watch(() => props.state?.current?.name, newRoute => {
      if (newRoute) {
        currentRoute.value = newRoute;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_v_list = _resolveComponent("v-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(me).accounts?.length > 1 || _unref(me).company?.accountant ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[30] || (_cache[30] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "My Firms", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.firms.list'),
          title: "My Firms",
          class: "nav-list-item",
          "data-cy": "my-firms-settings",
          onClick: _cache[0] || (_cache[0] = $event => navigateTo('settings.firms.list'))
        }, null, 8, ["current"])]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_cache[31] || (_cache[31] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "My Settings", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.user.info'),
          title: "My Info",
          class: "nav-list-item",
          "data-cy": "my-info-settings",
          onClick: _cache[1] || (_cache[1] = $event => navigateTo('settings.user.info'))
        }, null, 8, ["current"]), _unref(me).access?.setup || _unref(me).permissions?.time?.viewRates ? (_openBlock(), _createBlock(LlListItem, {
          key: 0,
          nav: "",
          current: isRouteActive('settings.user.billing'),
          title: "My Rates",
          class: "nav-list-item",
          "data-cy": "my-rates-settings",
          onClick: _cache[2] || (_cache[2] = $event => navigateTo('settings.user.billing'))
        }, null, 8, ["current"])) : _createCommentVNode("", true), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.user.tools'),
          title: "Tools",
          class: "nav-list-item",
          "data-cy": "user-tools-settings",
          onClick: _cache[3] || (_cache[3] = $event => navigateTo('settings.user.tools'))
        }, null, 8, ["current"])]),
        _: 1
      })]), _unref(me).access?.billing || _unref(me).access?.setup ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[32] || (_cache[32] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "Team Settings", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.shared.tasks'),
          title: "Snippets and Short Codes",
          class: "nav-list-item",
          "data-cy": "snippets-short-codes-settings",
          onClick: _cache[4] || (_cache[4] = $event => navigateTo('settings.shared.tasks'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.shared.tags'),
          title: "Practice Areas",
          class: "nav-list-item",
          "data-cy": "practice-area-settings",
          onClick: _cache[5] || (_cache[5] = $event => navigateTo('settings.shared.tags'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.shared.charges'),
          title: "Fixed Fee Templates",
          class: "nav-list-item",
          "data-cy": "fixed-fee-templates-settings",
          onClick: _cache[6] || (_cache[6] = $event => navigateTo('settings.shared.charges'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.shared.expenses'),
          title: "Expense Templates",
          class: "nav-list-item",
          "data-cy": "expense-templates-settings",
          onClick: _cache[7] || (_cache[7] = $event => navigateTo('settings.shared.expenses'))
        }, null, 8, ["current"])]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(me).access?.setup ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[33] || (_cache[33] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "Firm Setup", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.info'),
          title: "Firm Info",
          class: "nav-list-item",
          "data-cy": "firm-info-settings",
          onClick: _cache[8] || (_cache[8] = $event => navigateTo('settings.company.info'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.maxioCompanySubscription'),
          title: "Subscription",
          class: "nav-list-item",
          "data-cy": "subscription-settings",
          onClick: _cache[9] || (_cache[9] = $event => navigateTo('settings.company.maxioCompanySubscription'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.users'),
          title: "Users",
          class: "nav-list-item",
          "data-cy": "user-settings",
          onClick: _cache[10] || (_cache[10] = $event => navigateTo('settings.company.users'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.roles'),
          title: "User Permissions",
          class: "nav-list-item",
          "data-cy": "user-permissions-settings",
          onClick: _cache[11] || (_cache[11] = $event => navigateTo('settings.company.roles'))
        }, null, 8, ["current"]), _unref(me).features?.rateGroups ? (_openBlock(), _createBlock(LlListItem, {
          key: 0,
          nav: "",
          current: isRouteActive('settings.company.rateGroups'),
          title: "Rate Groups",
          class: "nav-list-item",
          "data-cy": "rate-groups-settings",
          onClick: _cache[12] || (_cache[12] = $event => navigateTo('settings.company.rateGroups'))
        }, null, 8, ["current"])) : _createCommentVNode("", true), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.trust'),
          title: "Trust Accounting",
          class: "nav-list-item",
          "data-cy": "trust-accounting-settings",
          onClick: _cache[13] || (_cache[13] = $event => navigateTo('settings.company.trust'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.workflow'),
          title: "Billing (Workflow/Fees)",
          class: "nav-list-item",
          "data-cy": "billing-workflow-settings",
          onClick: _cache[14] || (_cache[14] = $event => navigateTo('settings.company.workflow'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.ledes'),
          title: "LEDES",
          class: "nav-list-item",
          "data-cy": "ledes-settings",
          onClick: _cache[15] || (_cache[15] = $event => navigateTo('settings.company.ledes'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.invoice'),
          title: "Invoice Presentation",
          class: "nav-list-item",
          "data-cy": "invoice-presentation-settings",
          onClick: _cache[16] || (_cache[16] = $event => navigateTo('settings.company.invoice'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.invoiceEmail'),
          title: _unref(me).features?.leanlawInvoice ? 'Invoice Email' : 'Email Settings',
          class: "nav-list-item",
          "data-cy": "invoice-email-settings",
          onClick: _cache[17] || (_cache[17] = $event => navigateTo('settings.company.invoiceEmail'))
        }, null, 8, ["current", "title"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.reports'),
          title: "Compensation Tracking",
          class: "nav-list-item",
          "data-cy": "compensation-tracking-settings",
          onClick: _cache[18] || (_cache[18] = $event => navigateTo('settings.company.reports'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.autoIDs'),
          title: `Client and ${_unref(me).terms?.Matter || 'Matter'} IDs`,
          class: "nav-list-item",
          "data-cy": "client-matter-id-settings",
          onClick: _cache[19] || (_cache[19] = $event => navigateTo('settings.company.autoIDs'))
        }, null, 8, ["current", "title"]), _unref(me).features?.customFields2 ? (_openBlock(), _createBlock(LlListItem, {
          key: 1,
          nav: "",
          current: isRouteActive('settings.company.customFields2'),
          title: "Custom Fields (Field Mapping)",
          class: "nav-list-item",
          "data-cy": "custom-fields-settings",
          onClick: _cache[20] || (_cache[20] = $event => navigateTo('settings.company.customFields2'))
        }, null, 8, ["current"])) : (_openBlock(), _createBlock(LlListItem, {
          key: 2,
          nav: "",
          current: isRouteActive('settings.company.fieldMapping'),
          title: "Field Mapping",
          class: "nav-list-item",
          "data-cy": "field-mapping-settings",
          onClick: _cache[21] || (_cache[21] = $event => navigateTo('settings.company.fieldMapping'))
        }, null, 8, ["current"]))]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(me).access?.setup || _unref(me).features?.m365 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[34] || (_cache[34] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "Integrations", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_unref(me).access?.setup ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.billing'),
          title: "QuickBooks",
          class: "nav-list-item",
          "data-cy": "quickbooks-settings",
          onClick: _cache[22] || (_cache[22] = $event => navigateTo('settings.company.billing'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.api'),
          title: "API",
          class: "nav-list-item",
          "data-cy": "api-settings",
          onClick: _cache[23] || (_cache[23] = $event => navigateTo('settings.company.api'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.integrations'),
          title: "Confido Legal",
          class: "nav-list-item",
          "data-cy": "confido-legal-settings",
          onClick: _cache[24] || (_cache[24] = $event => navigateTo('settings.company.integrations'))
        }, null, 8, ["current"]), _createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.netdocs'),
          title: "NetDocuments",
          class: "nav-list-item",
          "data-cy": "netdocuments-settings",
          onClick: _cache[25] || (_cache[25] = $event => navigateTo('settings.company.netdocs'))
        }, null, 8, ["current"]), _unref(me).features?.paayabli ? (_openBlock(), _createBlock(LlListItem, {
          key: 0,
          nav: "",
          current: isRouteActive('settings.company.payabli'),
          title: "Payabli",
          class: "nav-list-item",
          "data-cy": "payabli-settings",
          onClick: _cache[26] || (_cache[26] = $event => navigateTo('settings.company.payabli'))
        }, null, 8, ["current"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _unref(me).features?.m365 ? (_openBlock(), _createBlock(LlListItem, {
          key: 1,
          nav: "",
          current: isRouteActive('settings.company.m365'),
          title: "Microsoft 365",
          class: "nav-list-item",
          "data-cy": "microsoft-365-settings",
          onClick: _cache[27] || (_cache[27] = $event => navigateTo('settings.company.m365'))
        }, null, 8, ["current"])) : _createCommentVNode("", true), _unref(me).features?.agentSettings && _unref(me).access?.setup ? (_openBlock(), _createBlock(LlListItem, {
          key: 2,
          nav: "",
          current: isRouteActive('settings.company.agentAccess'),
          title: "AI Agent Access",
          class: "nav-list-item",
          "data-cy": "agent-access-settings",
          onClick: _cache[28] || (_cache[28] = $event => navigateTo('settings.company.agentAccess'))
        }, null, 8, ["current"])) : _createCommentVNode("", true)]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(me).company?.status === 'test' && _unref(me).access?.setup ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[36] || (_cache[36] = _createElementVNode("h4", {
        class: "text-subtitle-1 font-weight-medium mb-0 text-grey-darken-2"
      }, "Internal", -1)), _createVNode(_component_v_list, {
        density: "compact",
        nav: "",
        class: "pa-0"
      }, {
        default: _withCtx(() => [_createVNode(LlListItem, {
          nav: "",
          current: isRouteActive('settings.company.reset'),
          class: "nav-list-item",
          "data-cy": "reset-account-settings",
          onClick: _cache[29] || (_cache[29] = $event => navigateTo('settings.company.reset'))
        }, {
          default: _withCtx(() => [_createVNode(LlIcon, {
            icon: "mdi-alert",
            color: "warning",
            size: "small",
            class: "mr-2"
          }), _cache[35] || (_cache[35] = _createTextVNode(" Reset Account ", -1))]),
          _: 1
        }, 8, ["current"])]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
};